if (!customElements.get('cart-pro-series-upsell')) {
  class CartProSeriesUpsell extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.button = this.querySelector('[data-pro-series-upgrade]');
      this.status = this.querySelector('[data-pro-series-upgrade-status]');

      if (!this.button) return;
      this.button.addEventListener('click', this.upgrade.bind(this));
    }

    async upgrade() {
      if (this.button.disabled) return;

      const sourceKey = this.dataset.sourceKey;
      const targetVariantId = Number(this.dataset.targetVariantId);
      const quantity = Math.max(1, Number(this.dataset.sourceQuantity) || 1);
      const sellingPlanId = Number(this.dataset.sellingPlanId) || null;

      if (!sourceKey || !targetVariantId) {
        this.setError('This upgrade is currently unavailable.');
        return;
      }

      const originalText = this.button.querySelector('.kt-button__text-value')?.textContent || 'Upgrade to Pro Series';
      this.setLoading(true, 'Upgrading…');

      try {
        const item = {
          id: targetVariantId,
          quantity,
          properties: {
            _pro_series_upgrade: 'true',
            _upgraded_from_line: sourceKey
          }
        };

        if (sellingPlanId) item.selling_plan = sellingPlanId;

        const addResponse = await fetch(`${window.KROWN?.settings?.routes?.cart_add_url || '/cart/add.js'}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [item] })
        });

        if (!addResponse.ok) {
          const error = await addResponse.json().catch(() => ({}));
          throw new Error(error.description || 'The Pro Series backpack could not be added.');
        }

        const removeResponse = await fetch(`${window.KROWN?.settings?.routes?.cart_change_url || '/cart/change.js'}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: sourceKey, quantity: 0 })
        });

        if (!removeResponse.ok) {
          throw new Error('The original backpack could not be removed. Please review your cart.');
        }

        this.setLoading(true, 'Upgraded');

        document.dispatchEvent(new CustomEvent('cart-updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('krown:cart:update', { bubbles: true }));

        if (typeof window.refreshCart === 'function') {
          await window.refreshCart(true);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error('[Pro Series upgrade]', error);
        this.setError(error.message || 'Something went wrong. Please try again.');
        this.setLoading(false, originalText);
      }
    }

    setLoading(isLoading, text) {
      this.button.disabled = isLoading;
      this.button.classList.toggle('kt-processing', isLoading);

      this.button.querySelectorAll('.kt-button__text-value, .kt-button__vertical-movement-text-value').forEach((element) => {
        element.textContent = text;
      });

      if (isLoading && this.status) this.status.textContent = '';
    }

    setError(message) {
      if (this.status) this.status.textContent = message;
    }
  }

  customElements.define('cart-pro-series-upsell', CartProSeriesUpsell);
}
